export const SET_STAGING = 'SET_STAGING';